import {useState, useEffect} from 'react';
import { fetchPageLevelAccess } from "../services/pageLevelAccessService";
import { useNavigate } from 'react-router-dom';
import { handleErrors } from '../utils/errorHandler';
import { sanitizePathSegment } from '../utils/apiPathUtils';

export const usePageLevelAccess = (pageUrl) => {
    const [pageAccessData, setPageAccessData] = useState(null);
    const navigate = useNavigate();
    const safePageUrl = sanitizePathSegment(pageUrl);

    useEffect(() => {
        const fetchAccessData = async () => {
            try {
                const data = await fetchPageLevelAccess(safePageUrl);
                if(data){
                    setPageAccessData(data);
                } else{
                    navigate('/404-error-page');
                }
                
            } catch (err) {
                handleErrors(err);
            }
        };

        if (safePageUrl) {
            fetchAccessData();
        }
    }, [safePageUrl, navigate]);
    return { pageAccessData};
};
